export const Dot = () => (
  <svg fill="none" height="4" viewBox="0 0 3 4" width="3" xmlns="http://www.w3.org/2000/svg">
    <circle cx="1.75" cy="1.9502" fill="#666666" r="1.25" />
  </svg>
)
